import React from "react";
import Grain from "../Grain/Grain";
import Reveal from "../Reveal/Reveal";
import { FEATURED_TESTIMONIAL, TESTIMONIALS } from "../../data/siteContent";
import "./styles.css";

const TestimonialCard = ({ index, quote, name, role, hidden = false }) => (
  <div className="testi-card" aria-hidden={hidden || undefined}>
    <span className="n">{String(index + 1).padStart(2, "0")}</span>
    <p>“{quote}”</p>
    <div className="who">
      <div className="avatar">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21a8 8 0 0 1 16 0" />
        </svg>
      </div>
      <div>
        <strong>{name}</strong>
        <span>{role}</span>
      </div>
    </div>
  </div>
);

const Testimonials = () => {
  const featured = FEATURED_TESTIMONIAL;

  return (
    <section className="testimonials paper" id="testimonials">
      <Grain variant="paper" />
      <div className="container">
        <Reveal className="section-head">
          <span className="tag">Quem já usa</span>
          <h2 className="display">Cirurgiões que ganharam tempo de volta</h2>
        </Reveal>

        <div className="testi-top">
          <Reveal className="testi-photo">
            <img src={`${process.env.PUBLIC_URL}${featured.photo}`} alt={featured.photoAlt} loading="lazy" />
            <span className="stamp stamp-red">{featured.stamp}</span>
          </Reveal>
          <Reveal className="testi-quote" delay={1}>
            <blockquote>“{featured.quote}”</blockquote>
            <div className="who">
              <strong>{featured.name}</strong>
              <span>{featured.role}</span>
            </div>
          </Reveal>
        </div>

        <Reveal className="rail" aria-hidden="true">
          <span className="node" />
          <span className="seg" />
          <span className="node" />
          <span className="seg" />
          <span className="node" />
          <span className="seg" />
          <span className="node" />
        </Reveal>

        <Reveal className="ticker" aria-label="Depoimentos">
          {/* A lista aparece duas vezes para o carrossel dar a volta sem emenda. */}
          <div className="ticker-track">
            {TESTIMONIALS.map((testimonial, i) => (
              <TestimonialCard key={testimonial.name} index={i} {...testimonial} />
            ))}
            {TESTIMONIALS.map((testimonial, i) => (
              <TestimonialCard key={`copy-${testimonial.name}`} index={i} hidden {...testimonial} />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Testimonials;
